'use client';
import React from 'react';

import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa6';
import Link from 'next/link';
import NextImage from '@/features/Image';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
const socialKeys = [
  'facebook_link',
  'instagram_link',
  'youtube_link',
  'hot_deals_start_datetime',
  'hot_deals_end_datetime',
];
const Footer = () => {
  const { data } = useFetcherCSR(`/api/v2/general-settings`);

  const socialData = data?.data?.reduce((acc: any, item: any) => {
    if (socialKeys.includes(item.type) && item.value) {
      acc[item.type] = item.value;
    }
    return acc;
  }, {});
  if (data) {
    return (
      <footer className="footer ">
        <div className="footer__top">
          <div className="container">
            <div className="footer__top-wrapper">
              <div className="row gy-5 gx-2 mb-4">
                <div className="col-xl-4 col-lg-3 col-md-6 col-sm-8 col-12">
                  <div className="footer__about">
                    <Link href="/" className="footer__about-logo">
                      <NextImage
                        width={113}
                        height={80}
                        src={'/images/logo/footer-logo.png'}
                        alt="Logo"
                      />
                    </Link>
                    <p className="footer__about-moto ">
                      We are ensuring a delightful shopping experience for every
                      customer.
                    </p>
                    <div className="footer__links-tittle">
                      <h4> Download App</h4>
                    </div>
                    <div className="footer__social">
                      <ul className="social">
                        <li className="social__item">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.thetork.kirei&hl=en"
                            target="_blank"
                          >
                            <NextImage
                              width={137}
                              height={39}
                              style={{ borderRadius: '6px' }}
                              src="/images/banner/1.png"
                              alt=""
                            />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href="https://apps.apple.com/hu/app/kirei/id6502335026"
                            target="_blank"
                          >
                            <NextImage
                              width={137}
                              height={39}
                              style={{ borderRadius: '6px' }}
                              src="/images/banner/2.png"
                              alt=""
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-4 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>Kirei</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/testimonials">Testimonials</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/responsible-disclosure">
                            Responsible - Disclosure
                          </Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/privacy-policy">Privacy Policy</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/term-condition">Terms & Conditions</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/blogs">Blogs</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>Customer Service</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/faq">Frequently Asked Questions</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/shipping-delivery">
                            Shipping & Delivery
                          </Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/return-refund">Returns & Refunds</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/personal-recommendation/skincare-recommendation">
                            Ai Suggestion
                          </Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/group-shopping">Group shopping</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>More Information</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/beauty-tips">Beauty Tips</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/kirei-tube">KireiTube</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/check-expiry">Product expiry</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/community">Kirei Community</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <a
                            target="_blank"
                            href="http://m.me/ExpertConsultancyByKirei"
                          >
                            Ask The Expert
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-4 pt-xl-5">
              <NextImage
                width={1920}
                height={137}
                style={{ borderRadius: '12px' }}
                src="/images/banner/footer.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="container">
            <div className="footer__bottom-wrapper">
              <div className="footer__bottom-payment">
                <div className="footer__social">
                  <ul className="social">
                    <li className="social__item">
                      <Link
                        href={`${socialData?.facebook_link}`}
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li
                      className="
                    "
                    >
                      <Link
                        href={`${socialData?.instagram_link}`}
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaInstagram />
                      </Link>
                    </li>
                    <li className="social__item">
                      <Link
                        href={`${socialData?.youtube_link}`}
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer__bottom-copyright">
                <p className=" mb-0">Kirei © 2025. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  } else {
    return (
      <footer className="footer ">
        <div className="footer__top">
          <div className="container">
            <div className="footer__top-wrapper">
              <div className="row gy-5 gx-2 mb-4">
                <div className="col-xl-4 col-lg-3 col-md-6 col-sm-8 col-12">
                  <div className="footer__about">
                    <Link href="/" className="footer__about-logo">
                      <NextImage
                        width={113}
                        height={80}
                        // src="/images/logo/logo.svg"
                        src={'/images/logo/footer-logo.png'}
                        alt="Logo"
                      />
                    </Link>
                    <p className="footer__about-moto ">
                      We are ensuring a delightful shopping experience for every
                      customer.
                    </p>
                    <div className="footer__links-tittle">
                      <h4> Download App</h4>
                    </div>
                    <div className="footer__social">
                      <ul className="social">
                        <Link
                          href={
                            'https://play.google.com/store/apps/details?id=com.thetork.kirei'
                          }
                        >
                          <li className="social__item">
                            <NextImage
                              width={137}
                              height={39}
                              style={{ borderRadius: '6px' }}
                              src="/images/banner/1.jpg"
                              alt=""
                            />
                          </li>
                        </Link>
                        <Link
                          href={
                            'https://apps.apple.com/hu/app/kirei/id6502335026'
                          }
                        >
                          <li className="social__item">
                            <NextImage
                              width={137}
                              height={39}
                              style={{ borderRadius: '6px' }}
                              src="/images/banner/2.jpg"
                              alt=""
                            />
                          </li>
                        </Link>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-4 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>Kirei</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/testimonials">Testimonials</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/responsible-disclosure">
                            Responsible - Disclosure
                          </Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/privacy-policy">Privacy Policy</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/term-condition">Terms & Conditions</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>Customer Service</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/faq">Frequently Asked Questions</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/shipping-delivery">
                            Shipping & Delivery
                          </Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/return-refund">Returns & Refunds</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/group-shopping">Group shopping</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="footer__links">
                    <div className="footer__links-tittle">
                      <h4>More Information</h4>
                    </div>
                    <div className="footer__links-content">
                      <ul className="footer__linklist">
                        <li className="footer__linklist-item">
                          <Link href="/beauty-tips">Beauty Tips</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/kirei-tube">KireiTube</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/check-expiry">Product expiry</Link>
                        </li>
                        <li className="footer__linklist-item">
                          <Link href="/community">Kirei Community</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-4 pt-xl-5">
              <NextImage
                width={1920}
                height={137}
                style={{ borderRadius: '12px' }}
                src="/images/banner/footer.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="container">
            <div className="footer__bottom-wrapper">
              <div className="footer__bottom-payment">
                <div className="footer__social">
                  <ul className="social">
                    <li className="social__item">
                      <Link
                        href="#"
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li
                      className="
              "
                    >
                      <Link
                        href="#"
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaInstagram />
                      </Link>
                    </li>
                    <li className="social__item">
                      <Link
                        href="#"
                        className="social__link social__link--style2"
                        target="_blank"
                      >
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer__bottom-copyright">
                <p className=" mb-0">Kirei © 2025. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
};
export default Footer;
